export enum Routes {
  HOME = '/',

  API_CLIENT = '/api-client',
  AUDIT_LOG = '/audit-log',
  VISIBILITY_MANAGEMENT = '/visibility-management',

  NOT_FOUND = '/not-found',

  FORBIDDEN = '/forbidden',

  NOA_SPACE = '/noa-space',

  LOGOUT = '/logout',
}
